import { Component, OnInit } from '@angular/core';
import { company_details } from 'src/app/global/global-variables';

@Component({
  selector: 'app-reports-header',
  templateUrl: './reports-header.component.html',
  styleUrls: ['./reports-header.component.scss']
})
export class ReportsHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  
  comapanyDetails = {
    name: company_details.name,
    address: company_details.address
  }

}
